import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from '../../shared/models/auth.service';
import { ApplicationRouteURL } from '../../shared/config';
import { Router } from '@angular/router';

@Component({
  selector: 'wego-credit-card-payment-popup',
  template: require('../views/creditcard-payment-popup.component.html'),
  providers: []
})
export class CreditCardPaymentPopupComponent implements OnInit {
  public errorMessageValue: string;
  public isAllowPayment: boolean;
  @ViewChild('creditCardPaymentModal')
  public creditCardPaymentModal: ModalDirective;
  @Output('onProceed') onProceed = new EventEmitter();
  @Output('onCancel') onCancel = new EventEmitter();

  @Output('isAllowInitialPayment')
  isAllowInitialPayment = new EventEmitter<string>();

  @Input('initialPaymentPopupTitle') initialPaymentPopupTitle: string;
  @Input('popupDescription') popupDescription: string;
  _errorMessage: string;

  @Input()
  set errorMessage(errorMessage: string) {
    if (errorMessage) {
      let stringErrorMessage = errorMessage.substring(
        0,
        errorMessage.indexOf(':')
      );
      this._errorMessage = stringErrorMessage && stringErrorMessage.trim();
    }
  }
  get errorMessage() {
    return this._errorMessage;
  }

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {}

  public show(): void {
    this.errorMessage = '';
    this._errorMessage = '';
    this.isAllowPayment = false;
    this.creditCardPaymentModal.show();
  }

  public hide(): void {
    this.creditCardPaymentModal.hide();
  }

  public GetCheckedValue($event: any) {
    this.isAllowInitialPayment.emit($event.currentTarget.checked);
  }

  private Proceed() {
    this.onProceed.emit();
  }

  private Cancel($event: any) {
    this.hide();

    this.onCancel.emit($event);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/creditcardpaymentpopup/components/creditcard-payment-popup.component.ts